<template>
    <main id="container-wrap">
        <!-- Header -->
        <section id="content">

        <!-- Main Banner -->
            <Header :status='status' 
                    @message='handlePopupMessage'/>

            <Signin v-if='status == "signin"'
                    ref='signin'
                    @message='handlePopupMessage'
                    @complete='handleCouponComplete' />
            <Register v-if='status == "coupon"' 
                      @message='handlePopupMessage'
                      @complete='handleCouponComplete'/>
            
            <Complete v-if='status == "complete"'
                      :code='completeCouponCode' />

        </section>

        <Footer />

        <Popup :message='message' v-if="message != ''"
                @message='handlePopupMessage' />

    </main>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
import Signin from './Signin'
import Popup from './Popup'
import Register from './Register'
import Complete from './Complete'
export default {
    name: 'coupon',
    components: { Header, Footer, Signin, Popup, Register, Complete },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['en'];
        const lang = this.$store.state.lang;
	    return {
            l10:l10n,
            changedLanguage:lang,
            lang:lang,

            status: 'signin',
            message: '',
            messageType: null,
            completeCouponCode: '',
        }
    },
    created() {
        const sessionId = this.$store.getters.getSessionId
        const isSignedIn = this.$store.getters.isSignedIn
        if (isSignedIn && sessionId) {
            this.$store.dispatch("verifySession", { sessionId }).then(() => {
                this.status = 'coupon'
            });
        }
    },
    mounted() {
        window.scrollTo(0, 0)
    },
    methods: {
        handleCouponComplete(data) {
            if (this.status == 'signin') {
                this.status = 'coupon'
            } else if (this.status == 'coupon') {
                this.status = 'complete'
                this.completeCouponCode = data
            }

            window.scrollTo({left:0, top:document.getElementById('promo1').offsetTop, behavior:'smooth'})
        },

        handlePopupMessage(message, type) {
            this.message = message

            if (message == '') {
                if (this.messageType == 'recover-complete') {
                    this.$refs.signin.setStatus('signin')
                } else if (this.messageType == 'signout') {
                    location.href = location.pathname
                }
            }
            
            this.messageType = type
        },

    }
}
</script>
<style src="@/assets/coupon/style.css" scoped></style>
